import { IMEventBus } from "lib/mp-stjk-im-service"
import ImageService from 'lib/ImageService'
// import {getPrivateUrl,getPublicImageUrl} from 'lib/ImageService'

Component({
  /**
   * 组件的属性列表
   */
  properties: {
    // 展示所有图片消息集合
    imgUrls: {
      type: Array,
      value: [],
    },
    msg: {
      type: Object,
      value: {},
      observer: function (msgInfo) {
        let msgBody;
        switch (msgInfo.subType) {
          // 主诉卡片消息
          case 200:
            msgBody = JSON.parse(msgInfo.content);
            this.setData({
              messageText: msgBody.ums,
              msgBody
            });
            break;
          // 问诊结束消息
          // 问诊结束消息
          case 10011:
            if (msgInfo.isNew) {
              IMEventBus.trigger(
                "RESET_FOOTER_CONTAINER_HEIGHT",
                0
              );
            }
            this.setData({
              messageText: msgInfo.content
            });
            break;
          // 转诊
          case 10031:
            msgBody = JSON.parse(msgInfo.content);
            let feature = {};
            if (typeof msgInfo.feature === 'string') {
              try {
                feature = JSON.parse(msgInfo.feature);
              } catch (e) { }
            } else if (typeof msgInfo.feature === 'object') {
              feature = msgInfo.feature;
            }
            // 添加白板号和执业医院id
            msgBody.wbNo = feature.wbNo || '';
            msgBody.hospitalId = feature.hospitalId || '';
            this.setData({
              msgBody
            });
            break;
          // 通用卡片
          case 100:
            msgBody = JSON.parse(msgInfo.content);
            this.setData({
              msgBody
            });
            break;
          // 历史消息卡片
          case 102:
            msgBody = JSON.parse(msgInfo.content);
            this.setData({
              msgBody
            });
            break;
          // 绑定关系
          case 300:
            {
              msgBody = JSON.parse(msgInfo.content);
              let feature = {};
              if (typeof msgInfo.feature === 'string') {
                try {
                  feature = JSON.parse(msgInfo.feature);
                } catch (e) { }
              } else if (typeof msgInfo.feature === 'object') {
                feature = msgInfo.feature;
              }
              let imgUrl = feature.f3 ? ImageService.getPublicImageUrl(feature.f3) : "";
              // let imgUrl = feature.f3 ? getPublicImageUrl(feature.f3) : "";
              msgBody.doctorAvatar = imgUrl;
              this.setData({
                msgBody
              });
            }
            break;
          // 人机消息
          case 2000:
            const { content = '' } = JSON.parse(msgInfo.content);
            if (content) {
              msgBody = JSON.parse(
                content
              );
              this.setData({
                msgBody
              });
            }

            break;
        }
      }
    },
  },

  /**
   * 组件的初始数据
   */
  data: {
    messageText: "",
    msgBody: {}
  },

  /**
   * 组件的方法列表
   */
  methods: {}
});
